import { useEffect, useState } from "react";
import { FileItemType } from "../../types/communication/communicationDataType";
import CameraUploadListCmp from "../custom-camera/CameraUploadListCmp";
import { SectionCameraFotoContainer } from "../styled/File.style";
import { PhotoTypeEnum } from "../../types/commonTypes";

export interface FotoMultiConfirmSectionProps {
    fileType: PhotoTypeEnum
    additionalBeInfo: any
    files: FileItemType[]
    setFiles: any,
    arrayDbPropSync?: string
    textLabel?: string
    titleImageDetail?: string
    totPhotosForStepDone: number
    leftLabelCmp?: any
    mainLabelItem?: any
    overlaySuggestItem?: any
    addButtonInLastPlace?: boolean
    keepAddBtnAlwaysInList?: boolean
    onTotFotoIsRiched?: any
}

/* istanbul ignore next */
const FotoMultiConfirmSection = (props: FotoMultiConfirmSectionProps) => {
    const { files, setFiles, arrayDbPropSync, textLabel, titleImageDetail,
        totPhotosForStepDone, leftLabelCmp, mainLabelItem,
        overlaySuggestItem, addButtonInLastPlace, keepAddBtnAlwaysInList,
        fileType, additionalBeInfo, onTotFotoIsRiched } = props

    const [showCamera, setShowCamera] = useState(false)
    const [hideCameraAddButton, setHideCameraAddButton] = useState(false)

    const onCloseHandler = () => {
        setShowCamera(false)
    }

    useEffect(() => {
        if ((files?.length) >= totPhotosForStepDone) {
            setShowCamera(false)
            setHideCameraAddButton(true)
        } else {
            setHideCameraAddButton(false)
        }
        if (keepAddBtnAlwaysInList) {
            setHideCameraAddButton(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files?.length])

    return (
        <SectionCameraFotoContainer>
            {<CameraUploadListCmp
                fileType={fileType}
                additionalBeInfo={additionalBeInfo}
                onCloseHandler={onCloseHandler}
                leftItem={leftLabelCmp}
                mainLabelItem={mainLabelItem}
                overlaySuggestItem={overlaySuggestItem}
                showCamera={showCamera}
                setShowCamera={setShowCamera}
                needPhotoConfirmBeforeUploading={true}
                hideCameraAddButton={hideCameraAddButton}
                onTotFotoIsRiched={onTotFotoIsRiched}
                totPhotosForStepDone={totPhotosForStepDone}

                files={files}
                setFiles={setFiles}
                arrayDbPropSync={arrayDbPropSync}
                textLabel={textLabel}
                titleImageDetail={titleImageDetail}
                addButtonInLastPlace={addButtonInLastPlace}
            />}
        </SectionCameraFotoContainer>
    )
}

export default FotoMultiConfirmSection